<template>
 <Partner :name="name" />
</template>
<script setup lang="ts">
import Partner from '~/components/Partner.vue';

definePageMeta({
  layout: 'partner'
});


const route = useRoute();
const name = route.params.name;
</script>
